import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-1.jpg'
import _imports_1 from '@/assets/images/user-2.jpg'
import _imports_2 from '@/assets/images/user-3.jpg'
import _imports_3 from '@/assets/images/user-4.jpg'
import _imports_4 from '@/assets/images/user-5.jpg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "default-table-area recent-orders recent-style-two" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[26] || (_cache[26] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4\"><h3 class=\"mb-0\">Recent Orders</h3><div class=\"d-flex\"><form class=\"position-relative table-src-form\"><input type=\"text\" class=\"form-control\" placeholder=\"Search here\"><i class=\"material-symbols-outlined position-absolute top-50 start-0 translate-middle-y\"> search </i></form><select class=\"form-select month-select form-control\" aria-label=\"Default select example\"><option selected>Show All</option><option value=\"1\">Weekly</option><option value=\"2\">Monthly</option><option value=\"3\">Yearly</option></select></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[25] || (_cache[25] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "Order ID"),
                _createElementVNode("th", { scope: "col" }, "Customer"),
                _createElementVNode("th", { scope: "col" }, "Created"),
                _createElementVNode("th", { scope: "col" }, "Total"),
                _createElementVNode("th", { scope: "col" }, "Status")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[1] || (_cache[1] = _createElementVNode("td", null, "#JAN-2345", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "wh-40 rounded-3",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2 ps-1" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Sarah Johnson")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("td", null, "12 Jan, 2024", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("td", null, "$10,490", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-success bg-opacity-10 text-success p-2 fs-12 fw-normal" }, " Shipped ")
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("td", null, "#JAN-1323", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createElementVNode("img", {
                        src: _imports_1,
                        class: "wh-40 rounded-3",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2 ps-1" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Michael Smith")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("td", null, "08 Jan, 2024", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("td", null, "$6,575", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-info bg-opacity-10 text-info p-2 fs-12 fw-normal" }, " Confirmed ")
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[11] || (_cache[11] = _createElementVNode("td", null, "#DEC-1234", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "wh-40 rounded-3",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2 ps-1" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Emily Brown")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("td", null, "13 Dec, 2023", -1)),
                _cache[13] || (_cache[13] = _createElementVNode("td", null, "$12,870", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-danger bg-opacity-10 text-danger p-2 fs-12 fw-normal" }, " Pending ")
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[16] || (_cache[16] = _createElementVNode("td", null, "#DEC-3567", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createElementVNode("img", {
                        src: _imports_3,
                        class: "wh-40 rounded-3",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2 ps-1" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Jason Lee")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[17] || (_cache[17] = _createElementVNode("td", null, "05 Dec, 2023", -1)),
                _cache[18] || (_cache[18] = _createElementVNode("td", null, "$7,895", -1)),
                _cache[19] || (_cache[19] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-success bg-opacity-10 text-success p-2 fs-12 fw-normal" }, " Shipped ")
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[21] || (_cache[21] = _createElementVNode("td", null, "#DEC-1098", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                      _createElementVNode("img", {
                        src: _imports_4,
                        class: "wh-40 rounded-3",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2 ps-1" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Ashley Davis")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[22] || (_cache[22] = _createElementVNode("td", null, "01 Dec, 2023", -1)),
                _cache[23] || (_cache[23] = _createElementVNode("td", null, "$4,680", -1)),
                _cache[24] || (_cache[24] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-danger bg-opacity-10 text-danger p-2 fs-12 fw-normal" }, " Rejected ")
                ], -1))
              ])
            ])
          ])
        ]),
        _createVNode(_component_Pagination, {
          items: "8",
          total: "30"
        })
      ])
    ])
  ]))
}